import React from "react";
import { Heart, Users, User, Bike, PartyPopper, Leaf } from "lucide-react";

const PERSONAS = [
  {
    icon: Heart,
    title: "Couples & Honeymooners",
    desc: "A peaceful, romantic retreat for newly-wed couples and honeymooners — private balconies, candlelit dining, and the serene beauty of Sengulam Dam at your doorstep. The perfect couples getaway in Munnar.",
  },
  {
    icon: Users,
    title: "Families",
    desc: "Spacious rooms, home-cooked meals, safe open grounds, and a caring owner family on-site — ideal for North Indian families, South Indian families, and families with children of all ages visiting Munnar.",
  },
  {
    icon: User,
    title: "Solo Travellers",
    desc: "A safe, welcoming haven for solo travellers — men and women alike. Female solo travellers and single women travellers consistently rate Auracrest Haven as one of the safest and most comfortable stays in Munnar.",
  },
  {
    icon: Bike,
    title: "Bikers & Adventurers",
    desc: "Free spacious concrete parking, early breakfasts, and a prime location on the Munnar ghat roads make Auracrest Haven the favourite base camp for bikers, road-trippers, and adventure seekers.",
  },
  {
    icon: PartyPopper,
    title: "Friends Groups",
    desc: "Whether you are two friends, a group of boys, a group of girls, or a mixed group — our flexible accommodation, group dining, and activity-booking support make every friends trip to Munnar unforgettable.",
  },
  {
    icon: Leaf,
    title: "Nature & Wellness Seekers",
    desc: "Surrounded by cardamom and nutmeg plantations, with birdsong at dawn and a gurgling stream at night — Auracrest Haven is the ideal calm resort in Munnar for those seeking peace, quiet, and reconnection with nature.",
  },
];

const Travellers = () => (
  <section id="travellers" className="py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="text-center mb-14">
        <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#17a89b] mb-4">
          A Home for Every Traveller
        </p>
        <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 mb-4">
          Whoever You Are, You Belong Here
        </h2>
        <p className="text-neutral-600 max-w-3xl mx-auto leading-8">
          Auracrest Haven is not just a place to sleep — it is a sanctuary crafted for every kind of
          soul that finds its way to the misty hills of Munnar. Whether you arrive as a family, a
          couple, a group of friends, or entirely on your own, you will find warmth, safety, and a
          welcome that feels genuinely personal.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {PERSONAS.map((p) => (
          <div
            key={p.title}
            className="bg-neutral-50 rounded-2xl p-7 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300"
          >
            <div className="w-12 h-12 rounded-xl bg-[#e3faf7] flex items-center justify-center mb-5">
              <p.icon className="w-6 h-6 text-[#17a89b]" />
            </div>
            <h3 className="text-lg font-bold text-neutral-900 mb-3">{p.title}</h3>
            <p className="text-neutral-600 leading-7 text-sm">{p.desc}</p>
          </div>
        ))}
      </div>

      <p className="text-neutral-500 leading-8 text-sm md:text-base max-w-5xl mx-auto text-center mt-12">
        Auracrest Haven is widely regarded as one of the best places to stay in Munnar, Anachal,
        Sengulam, Muthuvankudy, Pallivasal, Adimali, Vellathooval, and Kunjithanni for families,
        couples, solo travellers, female solo travellers, single women, single men, bikers, friends
        groups, newly-wed couples, honeymooners, and budget travellers seeking a calm, safe, and
        welcoming resort experience in the Western Ghats of Kerala.
      </p>
    </div>
  </section>
);

export default Travellers;
